export const signInUserData = [
    {
        id: '21',
        avatar: `${process.env.PUBLIC_URL}/img/avatars/thumb-1.jpg`,
        userName: 'Charlie Howard',
        email: 'user1@themenate.net',
        password: '2005ipo'
    }
]